// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2BW3H","list":"PatternAutocomplete_list__3FabM"};